module.exports = __webpack_public_path__ + "static/media/h-2-01.61aa14d8.png";